import Spinner from "components/Spinner";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const Button = ({ className = "", children, loading, next, prev, icon, primary, danger, ...rest }) => {
  return (
    <button
      className={`font-semibold opacity-90 hover:opacity-100 whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-50 flex items-center space-x-2 transition-all duration-200
          ${
            primary
              ? "relative px-6 py-2 text-sm rounded-full text-white bg-sky-600/85 hover:bg-sky-600/95 active:bg-sky-700/95 backdrop-blur-xl backdrop-saturate-150 border border-white/30 shadow-[inset_0_1px_0_rgba(255,255,255,0.45),0_8px_20px_-6px_rgba(2,132,199,0.5)] hover:shadow-[inset_0_1px_0_rgba(255,255,255,0.5),0_10px_24px_-6px_rgba(2,132,199,0.6)] active:scale-[0.98]"
              : danger
              ? "text-red-600 hover:text-red-700 active:text-red-800 dark:text-red-700 dark:hover:text-red-800 dark:active:text-red-900"
              : "text-sky-600 hover:text-sky-700 active:text-sky-800"
          }
          ${className}
        `}
      {...rest}
      disabled={loading || rest.disabled}
    >
      {loading ? <Spinner size={16} text={null} /> : prev ? <IoChevronBack /> : icon ? icon : null}
      {children ? <div>{children}</div> : null}
      {next ? <IoChevronForward /> : null}
    </button>
  );
};

export default Button;
